import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'
import { filterCaseInsensitive, addressFilter } from '../../util'
import history from '../../history'
import PaginationComponent from '../../components/PaginationComponent'
import _ from 'lodash'
import { Tooltip, Spin } from 'antd'
import ScheduleModal from '../../components/drivers/scheduledDeliveries/ScheduleModal'
import Calendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { Link } from 'react-router-dom'

import { actions as scheduledDeliveriesActions } from '../../redux/modules/scheduledDeliveriesActions'
import { actions as vehiclesActions } from '../../redux/modules/vehiclesActions'
import { actions as driverActions } from '../../redux/modules/driverActions'

const localizer = Calendar.momentLocalizer(moment)

const propTypes = {}

class ScheduledDeliveriesContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: {},
      selectAll: 0,
      modalOpened: false,
      modalDetailOpened: false
    }

    this.props.fetchOpenRequests()
  }

  toggleRow = id => {
    const newSelected = Object.assign({}, this.state.selected)
    newSelected[id] = !this.state.selected[id]
    this.setState({
      selected: newSelected,
      selectAll: 2
    })
  }

  toggleSelectAll = () => {
    let newSelected = {}

    const openRequests = _.get(this.props, 'scheduledDeliveriesActions.openRequests')

    if (this.state.selectAll === 0) {
      openRequests.forEach(x => {
        newSelected[x.id] = true
      })
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    })
  }

  // here an ugly workaround to get the selected rows
  // just because we're using react-table on entire system
  handleSchedule = () => {
    const { selected } = this.state
    const openRequests = _.get(this.props, 'scheduledDeliveriesActions.openRequests')

    let arraySelected = []

    Object.getOwnPropertyNames(selected).forEach(function(val, idx, array) {
      if (selected[val]) {
        arraySelected.push(
          _.find(openRequests, openRequest => parseInt(val, 10) === parseInt(openRequest.id, 10))
        )
      }
    })

    if (arraySelected.length > 0) {
      this.setState({
        modalOpened: true,
        selectedOpenItems: arraySelected
      })
    }
  }

  toggleModal = () => {
    const { modalOpened } = this.state
    this.setState({
      modalOpened: !modalOpened
    })
  }

  removeSelectedOpenItems = openItemId => {
    const { selectedOpenItems } = this.state
    const newSelectedOpenItems = _.remove(
      selectedOpenItems,
      selectedOpenItem => parseInt(selectedOpenItem.id, 10) !== parseInt(openItemId, 10)
    )
    this.setState({
      selectedOpenItems: newSelectedOpenItems
    })
  }

  addScheduledDelivery = formData => {
    this.props.addScheduledDelivery({
      scheduledDate: formData.scheduled_date,
      vehicle: formData.vehicle,
      driver: formData.driver,
      arrayOpenItems: this.state.selectedOpenItems
    })
    this.setState({
      selectedOpenItems: []
    })
    this.toggleModal()
    this.props.fetchOpenRequests()
  }

  getEvents = () => {
    const openRequests = _.get(this.props, 'scheduledDeliveriesActions.openRequests')
    let events = []

    if (openRequests) {
      for (const openRequest of openRequests) {
        if (openRequest.scheduledDelivery) {
          for (const scheduledDelivery of openRequest.scheduledDelivery) {
            const scheduledDate = _.get(scheduledDelivery, 'scheduled_date')
            if (scheduledDate) {
              events.push({
                start: moment(scheduledDate).format('MM/DD/YYYY'),
                end: moment(scheduledDate).format('MM/DD/YYYY'),
                title: openRequest.job_name,
                allDay: true,
                openRequest: openRequest
              })
            }
          }
        }
      }
    }

    return events
  }

  handleOpenScheduledDeliveryDetails = e => {
    const { openRequest } = e
    if (openRequest.type === 'driver_request') {
      history.push(
        `/jobView/${openRequest.job_id}/${openRequest.job_type}/driver-requests/modal/${
          openRequest.id
        }`
      )
    } else {
      const type = openRequest.job_type.replace('/', '-')
      history.push(
        `/jobView/${openRequest.job_id}/${type}/material-requests/modal/${openRequest.id}`
      )
    }
  }

  render() {
    const { modalOpened, selectedOpenItems } = this.state
    const openRequests = _.get(this.props, 'scheduledDeliveriesActions.openRequests')
    const loadingOpenRequests = _.get(this.props, 'scheduledDeliveriesActions.loading')
    const vehicles = _.get(this.props, 'vehiclesActions.payload.data')
    const drivers = _.get(this.props, 'driverActions.payload.data')
    if (openRequests) {
      openRequests.map(openRequest => {
        const lastItem = openRequest.scheduledDelivery.length - 1
        if (lastItem >= 0) {
          openRequest.scheduled_delivery = openRequest.scheduledDelivery[lastItem].scheduled_date
        }
        return openRequest
      })
    }
    return (
      <div>
        <div className="dataHeader">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link to="/drivers">Drivers</Link>
              </li>
            </ol>
          </nav>
          <h2>Driver's Itinerary</h2>
        </div>
        <div className="dataPanel">
          <div className="wrapPanel">
            <div className="row">
              <div
                className="col-12"
                style={{ padding: 10, backgroundColor: 'white', marginTop: 20 }}
              >
                <Calendar
                  localizer={localizer}
                  defaultView="week"
                  views={['week', 'day', 'agenda']}
                  events={this.getEvents()}
                  onSelectEvent={e => this.handleOpenScheduledDeliveryDetails(e)}
                />
              </div>
            </div>
            <div className="jobsBar">
              Open Requests
              <div style={{ display: 'flex' }}>
                <div className="jobsBarAdd" onClick={this.handleSchedule}>
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">SCHEDULE</div>
                </div>
              </div>
            </div>
            <ScheduleModal
              toggleModal={this.toggleModal}
              modalOpened={modalOpened}
              selectedOpenItems={selectedOpenItems}
              vehicles={vehicles}
              drivers={drivers}
              removeSelectedOpenItems={this.removeSelectedOpenItems}
              addScheduledDelivery={this.addScheduledDelivery}
            />
            {loadingOpenRequests && <Spin spinning />}
            {!loadingOpenRequests && (
              <ReactTable
                data={openRequests}
                filterable
                filtered={this.state.filtered}
                onFilteredChange={filtered => {
                  this.setState({ filtered })
                }}
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        id: 'checkbox',
                        accessor: '',
                        width: 50,
                        Cell: ({ original }) => {
                          return (
                            <input
                              type="checkbox"
                              className="checkbox"
                              checked={this.state.selected[original.id] === true}
                              onChange={() => this.toggleRow(original.id)}
                            />
                          )
                        },
                        Header: x => {
                          return (
                            <input
                              type="checkbox"
                              className="checkbox"
                              checked={this.state.selectAll === 1}
                              ref={input => {
                                if (input) {
                                  input.indeterminate = this.state.selectAll === 2
                                }
                              }}
                              onChange={() => this.toggleSelectAll()}
                            />
                          )
                        },
                        sortable: false
                      },
                      {
                        Header: 'Type',
                        id: 'type',
                        accessor: 'type',
                        Cell: d => {
                          const niceType =
                            d.original.type === 'material_request'
                              ? 'Material Request'
                              : 'Driver Request'
                          return <Tooltip title={niceType}>{niceType}</Tooltip>
                        }
                      },
                      {
                        Header: 'Number',
                        id: 'number',
                        accessor: 'number',
                        width: 70,
                        Cell: d => {
                          let url
                          const jobType = d.original.job_type.replace('/', '-')
                          if (d.original.type === 'material_request') {
                            url = `/jobView/${d.original.job_id}/${
                              jobType
                            }/material-requests/modal/${d.original.id}`
                          } else {
                            url = `/jobView/${d.original.job_id}/${jobType}/driver-requests/modal/${
                              d.original.id
                            }`
                          }
                          return <Link to={url}>{d.original.number}</Link>
                        }
                      },
                      {
                        Header: 'Job ID',
                        id: 'job_id',
                        accessor: 'job_id',
                        width: 70
                      },
                      {
                        Header: 'Job Name',
                        id: 'job_name',
                        accessor: 'job_name'
                      },
                      {
                        Header: 'Job Address',
                        id: 'job_address',
                        accessor: 'job_address',
                        Cell: d => {
                          const addressFiltered = addressFilter(d.original)
                          return <Tooltip title={addressFiltered}>{addressFiltered}</Tooltip>
                        },
                        filterMethod: (filter, row) => {
                          return (
                            addressFilter(row._original)
                              .toLowerCase()
                              .indexOf(filter.value.toLowerCase()) > -1
                          )
                        },
                        style: { whiteSpace: 'unset' }
                      },
                      {
                        Header: 'Description',
                        id: 'description',
                        accessor: 'description',
                        Cell: d => (
                          <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                        )
                      },
                      {
                        Header: 'Scheduled Delivery',
                        id: 'scheduled_delivery',
                        accessor: 'scheduled_delivery',
                        style: { whiteSpace: 'unset' },
                        width: 300,
                        Cell: d => {
                          const lastItem = d.original.scheduledDelivery.length - 1
                          return (
                            <div>
                              <div style={{ display: 'block' }}>
                                {d.original.scheduledDelivery.length > 0
                                  ? `Vehicle: ${
                                      d.original.scheduledDelivery[lastItem].vehicle_name
                                    }`
                                  : ''}
                              </div>
                              <div style={{ display: 'block' }}>
                                {' '}
                                {d.original.scheduledDelivery.length > 0
                                  ? `Driver: ${
                                      d.original.scheduledDelivery[lastItem].driver_first_name
                                    } ${d.original.scheduledDelivery[lastItem].driver_last_name}`
                                  : ''}
                              </div>
                              <div>
                                {' '}
                                {d.original.scheduledDelivery.length > 0 && (
                                  <Link
                                    to={`/drivers/delivery/${
                                      d.original.scheduledDelivery[lastItem].id
                                    }`}
                                  >
                                    Scheduled Date:{' '}
                                    {moment(
                                      d.original.scheduledDelivery[lastItem].scheduled_date
                                    ).format('M/D/YYYY')}
                                  </Link>
                                )}
                              </div>
                            </div>
                          )
                        },
                        filterMethod: (filter, row) => {
                          if (row._original.scheduledDelivery.length > 0) {
                            const lastItem = row._original.scheduledDelivery.length - 1
                            if (row._original.scheduledDelivery[lastItem].scheduled_date) {
                              return (
                                moment(row._original.scheduledDelivery[lastItem].scheduled_date)
                                  .format('M/D/YYYY')
                                  .indexOf(filter.value) > -1
                              )
                            }
                            return false
                          }
                        },
                        sortMethod: (a, b) => {
                          if (!a) return 1
                          if (!b) return -1
                          if (a && b) {
                            return moment(a).isSameOrBefore(moment(b))
                          }
                        }
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
            )}
            &copy; G-Tech Elevator Associates LLC
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (
  { authentication, scheduledDeliveriesActions, vehiclesActions, driverActions },
  ownProps
) => ({
  authentication,
  scheduledDeliveriesActions,
  vehiclesActions,
  driverActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, scheduledDeliveriesActions, vehiclesActions, driverActions),
    dispatch
  )
})

ScheduledDeliveriesContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ScheduledDeliveriesContainer)
)



// WEBPACK FOOTER //
// ./src/containers/drivers/ScheduledDeliveriesContainer.js